
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import {
  SKILLED_WORKER_SERVICE_TYPE,
  SKILLED_WORKER_INSIDE_SERVICE_TYPE,
} from "@/constants/services";

const MESSAGES = {
  headlines: {
    skilledWorker: "Unfortunately, your Skilled Worker Visa has been rejected by the Home Office.",
    sponsorLicence: "Unfortunately, your Sponsor Licence has been rejected by the Home Office.",
  },
  hint: "Our Expert will reach out to you to discuss the next steps.",
};

@Component
export default class RejectedByHO extends Vue {
  hintText = MESSAGES.hint;

  get isSWType() {
    return [SKILLED_WORKER_SERVICE_TYPE, SKILLED_WORKER_INSIDE_SERVICE_TYPE].includes(
      SMCases.caseType
    );
  }

  get headlineText() {
    return this.isSWType ? MESSAGES.headlines.skilledWorker : MESSAGES.headlines.sponsorLicence;
  }
}
